export { default as ComprobantModal } from './ComprobantModal/ComprobantModal';
